function shouldCancelAutocompleteCloseOnFocusOut(open, eventDetails) {
    return !open && eventDetails?.reason === 'focus-out' && eventDetails.event instanceof FocusEvent && eventDetails.event.relatedTarget instanceof Element && null !== eventDetails.event.relatedTarget.closest('[data-base-autocomplete-popup]');
}
function handleAutocompleteFocusOutClose(open, eventDetails) {
    if (!shouldCancelAutocompleteCloseOnFocusOut(open, eventDetails)) return false;
    eventDetails?.cancel?.();
    return true;
}
function preventAutocompleteInputBlur(event) {
    event.preventDefault();
}
export { handleAutocompleteFocusOutClose, preventAutocompleteInputBlur, shouldCancelAutocompleteCloseOnFocusOut };
